import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useNavigate } from "react-router-dom";
import { AuthForm } from "./AuthForm";
import { WholesaleForm } from "./wholesale/WholesaleRegistrationModal";
import { BrandLogo } from "./BrandLogo";
import { useShopMode } from "../context/ShopModeContext";
import {
  getPendingAuthSession,
  setAuthModalActive,
} from "../lib/authSession";

export const AuthModal = ({ open, mode = "login", onOpenChange }) => {
  const navigate = useNavigate();
  const { isWholesale } = useShopMode();
  
  const getInitialTab = (m) => {
    const saved = getPendingAuthSession();
    if (saved?.type === "wholesale_register") return "b2b";
    if (saved?.type === "retail_register") return "b2c";
    if (m === "b2b" || m === "b2b_register") return "b2b";
    if (m === "b2c" || m === "b2c_register") return "b2c";
    if (m === "register") return isWholesale ? "b2b" : "b2c";
    return "login";
  };

  const [activeTab, setActiveTab] = useState(() => getInitialTab(mode));

  useEffect(() => {
    const tab = (m) => {
      const saved = getPendingAuthSession();
      if (saved?.type === "wholesale_register") return "b2b";
      if (saved?.type === "retail_register") return "b2c";
      if (m === "b2b" || m === "b2b_register") return "b2b";
      if (m === "b2c" || m === "b2c_register") return "b2c";
      if (m === "register") return isWholesale ? "b2b" : "b2c";
      return "login";
    };
    setActiveTab(tab(mode));
  }, [mode, open, isWholesale]);

  useEffect(() => {
    setAuthModalActive(open, activeTab);
  }, [open, activeTab]);

  const handleOpenChange = (isOpen) => {
    setAuthModalActive(isOpen, activeTab);
    if (onOpenChange) onOpenChange(isOpen);
  };

  const onSuccess = (user) => {
    handleOpenChange(false);
    if (user.role === "admin" || user.role === "seller") navigate("/dashboard");
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        data-testid="auth-modal"
        className="bg-white border border-stone-200 text-stone-900 w-[95vw] max-w-[95vw] sm:max-w-md max-h-[90vh] overflow-y-auto overflow-x-hidden rounded-2xl sm:rounded-3xl p-5 sm:p-6 shadow-2xl"
      >
        <DialogHeader className="items-center text-center pb-2 w-full min-w-0">
          <BrandLogo size={36} />
          <DialogTitle className="font-serif-display text-xl sm:text-2xl text-[#0a2140] font-bold mt-1">
            {activeTab === "b2b" ? "Wholesale Registration" : "Welcome to Zaveri Trunk"}
          </DialogTitle>
          <DialogDescription className="text-stone-500 text-xs">
            {activeTab === "b2b"
              ? "Register your jewellery business to unlock protected wholesale pricing"
              : "Sign in or create an account to access orders & wishlist"}
          </DialogDescription>
        </DialogHeader>

        {/* ACTIVE FORM CONTENT */}
        <div className="pt-1 w-full min-w-0">
          {activeTab === "b2b" ? (
            <div className="space-y-3 w-full min-w-0">
              <WholesaleForm onSuccess={onSuccess} onDoneClose={() => onOpenChange(false)} />
              <div className="pt-2 border-t border-stone-100 flex items-center justify-center text-xs text-stone-600">
                <button
                  type="button"
                  onClick={() => setActiveTab("login")}
                  className="font-medium text-stone-600 hover:text-stone-900 cursor-pointer"
                >
                  Already registered? <strong className="text-[#0a2140] font-bold">Sign In</strong>
                </button>
              </div>
            </div>
          ) : (
            <AuthForm
              initialMode={activeTab === "b2c" ? "b2c_register" : "login"}
              onSuccess={onSuccess}
              onSwitchToB2B={() => setActiveTab("b2b")}
              onSwitchToB2C={() => setActiveTab("b2c")}
              onSwitchToLogin={() => setActiveTab("login")}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
